module.exports = __webpack_public_path__ + "static/media/01.071.0eb09215.webp";